// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.embed_remember-container_ANIl6,
.embed_remember-warning_FfY74,
.embed_sandboxed_eZ4ac {
    margin: 8px 0;
}

.embed_remember-container_ANIl6 {
    display: flex;
    align-items: center;
}

.embed_remember-checkbox_YTshR {
    margin-right: 8px;
}

.embed_remember-warning_FfY74 {
    padding: 0.5rem;
    border-radius: 0.25rem;
    background-color: rgba(255, 81, 81, 0.25);
    border: 1px solid red;
}`, "",{"version":3,"sources":["webpack://./src/components/tw-security-manager-modal/embed.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;;;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yCAAyC;IACzC,qBAAqB;AACzB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.remember-container,\n.remember-warning,\n.sandboxed {\n    margin: 8px 0;\n}\n\n.remember-container {\n    display: flex;\n    align-items: center;\n}\n\n.remember-checkbox {\n    margin-right: 8px;\n}\n\n.remember-warning {\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n    background-color: rgba(255, 81, 81, 0.25);\n    border: 1px solid red;\n}"],"sourceRoot":""}]);
// Exports
var _1 = `embed_remember-container_ANIl6`;
export { _1 as "remember-container" };
export var rememberContainer = `embed_remember-container_ANIl6`;
var _2 = `embed_remember-warning_FfY74`;
export { _2 as "remember-warning" };
export var rememberWarning = `embed_remember-warning_FfY74`;
export var sandboxed = `embed_sandboxed_eZ4ac`;
var _3 = `embed_remember-checkbox_YTshR`;
export { _3 as "remember-checkbox" };
export var rememberCheckbox = `embed_remember-checkbox_YTshR`;
export default ___CSS_LOADER_EXPORT___;
